/**
 * Pure H OS · Sprint 3 · Marketing OS shell.
 * Owns the /pureh/marketing/* sub-nav. Every child screen inherits
 * from the frozen Executive Warm v1 component library.
 */
import { NavLink, Outlet } from "react-router-dom";
import {
  LayoutDashboard, CalendarDays, Workflow, Image as ImageIcon,
  Wand2, Users, LineChart, ListChecks,
} from "lucide-react";
import { Megaphone } from "lucide-react";

const SUBNAV = [
  { to: "overview",   label: "Overview",     icon: LayoutDashboard },
  { to: "calendar",   label: "Calendar",     icon: CalendarDays    },
  { to: "pipeline",   label: "Pipeline",     icon: Workflow        },
  { to: "creative",   label: "Creative",     icon: ImageIcon       },
  { to: "copy",       label: "AI Copy",      icon: Wand2           },
  { to: "creators",   label: "Creators",     icon: Users           },
  { to: "channels",   label: "Channels",     icon: LineChart       },
  { to: "tasks",      label: "Tasks",        icon: ListChecks      },
];

export default function MarketingLayout() {
  return (
    <div data-testid="pureh-marketing">
      <div className="mb-4">
        <div className="text-[10px] uppercase tracking-[0.24em] text-slate-500 mb-2 inline-flex items-center gap-1.5">
          <Megaphone size={11} /> Marketing OS
        </div>
        <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">ORVAN Perfumes · Marketing</h1>
        <div className="mt-1 text-sm text-slate-500">
          6 campaigns · 3 in flight · 22 assets live · 7 creators active
        </div>
      </div>

      <nav
        data-testid="marketing-subnav"
        className="mb-6 -mx-1 overflow-x-auto"
      >
        <div
          className="inline-flex items-center gap-1 p-1"
          style={{
            background: "var(--ph-surface)",
            border: "1px solid var(--ph-border-subtle)",
            borderRadius: "var(--ph-radius-md)",
          }}
        >
          {SUBNAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`mkt-subnav-${item.to}`}
              className={({ isActive }) => "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium transition-colors " + (isActive ? "" : "")}
              style={({ isActive }: { isActive: boolean }) => ({
                background: isActive ? "var(--ph-surface-card)" : "transparent",
                color: isActive ? "var(--ph-ink-strong)" : "var(--ph-ink-muted)",
                borderRadius: "var(--ph-radius-sm)",
                boxShadow: isActive ? "var(--ph-shadow-card)" : "none",
                border: isActive ? "1px solid var(--ph-border-subtle)" : "1px solid transparent",
              })}
            >
              <item.icon size={13} />
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>

      <Outlet />
    </div>
  );
}
